module.exports = __webpack_public_path__ + "img/Russia.fdb63c58.png";